import { errorService } from './errorService'
import { userService } from './userService'
import { cleanResponseService } from './cleanResponseService'

export const services = {
  errorService,
  userService,
  cleanResponseService
}



// WEBPACK FOOTER //
// ./src/services/index.js